/**
 * P0.6 — export do Elo (CSV) gerado client-side. Legível por outro profissional,
 * sem jargão do app. Anexos sensíveis (restrito_anel) não saem aqui.
 */
import { ESPECIALIDADE_LABEL, PASSO_ESCADA_LABEL } from "../types";
import type { Alimento } from "../types";
import type { NotaSessao, Profissional } from "./types";

function csvCampo(v: string | number | null | undefined): string {
  const s = v === null || v === undefined ? "" : String(v);
  return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function notasParaCSV(
  notas: NotaSessao[],
  profissionais: Profissional[],
  alimentos: Alimento[],
): string {
  const nomeProf = (id: string) => profissionais.find((p) => p.id === id)?.nome ?? id;
  const nomeAlim = (id: string | null) =>
    id ? (alimentos.find((a) => a.id === id)?.nome ?? id) : null;
  const cab = [
    "data da sessão",
    "profissional",
    "especialidade",
    "objetivo",
    "alimento",
    "degrau observado",
    "degrau alvo",
    "atividades",
    "orientações para casa",
    "observações",
  ];
  const linhas = notas
    .slice()
    .sort((a, b) => a.data_sessao.localeCompare(b.data_sessao))
    .map((n) =>
      [
        new Date(n.data_sessao).toLocaleString("pt-BR"),
        nomeProf(n.profissional_id),
        ESPECIALIDADE_LABEL[n.especialidade],
        n.objetivo,
        nomeAlim(n.alimento_id),
        n.degrau_observado !== null ? PASSO_ESCADA_LABEL[n.degrau_observado] : null,
        n.degrau_alvo !== null ? PASSO_ESCADA_LABEL[n.degrau_alvo] : null,
        n.atividades.join(" · "),
        n.orientacoes_casa,
        n.observacoes,
      ]
        .map(csvCampo)
        .join(";"),
    );
  return [cab.join(";"), ...linhas].join("\r\n");
}
